/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Newsletter_Science_SubjectInputs */

const en_why_listening_newsletter_science_subject = /** @type {(inputs: Why_Listening_Newsletter_Science_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleep and memory`)
};

const es_why_listening_newsletter_science_subject = /** @type {(inputs: Why_Listening_Newsletter_Science_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sueño y memoria`)
};

/**
* | output |
* | --- |
* | "Sleep and memory" |
*
* @param {Why_Listening_Newsletter_Science_SubjectInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_newsletter_science_subject = /** @type {((inputs?: Why_Listening_Newsletter_Science_SubjectInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Newsletter_Science_SubjectInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_newsletter_science_subject(inputs)
	return en_why_listening_newsletter_science_subject(inputs)
});